import gql from 'graphql-tag'

export const SEARCH_JSTOR = gql`
  query SearchJstor($keywords: String!) {
    searchCitationSource(
      searchInput: { keywords: $keywords, provider: JOURNAL_JSTOR, from: 0 }
    ) {
      results {
        data {
          source
          ... on JournalSearchJSTOR {
            pubjournal {
              year
              month
              day
            }
            pubdatabase {
              yearaccessed
              monthaccessed
              dayaccessed
              db
              searchtype
              searchtext
            }
            issn {
              print
            }
            journal {
              title
            }
            publication_type
            datasource
            contributors {
              first
              middle
              last
              function
            }
          }
          pubtype {
            main
            suffix
          }
          other {
            datasource
            oclc
          }
        }
        display {
          title
          publisher
          year
          titleurl
        }
      }
    }
  }
`

export const SEARCH_WEBSITE = gql`
  query SearchWebsite($keywords: String!) {
    searchCitationSource(
      searchInput: { keywords: $keywords, provider: WEBSITE, from: 0 }
    ) {
      results {
        data {
          pubtype {
            main
          }
          ... on WebsiteSearch {
            pubonline {
              url
              dayaccessed
              monthaccessed
              yearaccessed
              title
              inst
              day
              month
              year
            }
            autocite {
              search
            }
            website {
              title
              summary
            }
          }
          source
          other {
            datasource
            oclc
          }
        }
        display {
          title
          summary
          url
          displayurl
          titleurl
        }
      }
    }
  }
`

export const SEARCH_WEBSITE_BRAVE = gql`
  query SearchWebsite($keywords: String!) {
    searchCitationSource(
      searchInput: { keywords: $keywords, provider: WEBSITE_BRAVE, from: 0 }
    ) {
      results {
        data {
          pubtype {
            main
          }
          ... on WebsiteSearch {
            pubonline {
              url
              dayaccessed
              monthaccessed
              yearaccessed
              title
              inst
              day
              month
              year
            }
            autocite {
              search
            }
            website {
              title
              summary
            }
          }
          source
          other {
            datasource
            oclc
          }
        }
        display {
          title
          summary
          url
          displayurl
          titleurl
        }
      }
    }
  }
`

export const SEARCH_JOURNAL = gql`
  query SearchJournal(
    $keywords: String!
    $crossrefResultCountVariant: CrossrefResultCountVariant
  ) {
    searchCitationSource(
      searchInput: {
        keywords: $keywords
        provider: JOURNAL_CROSSREF
        from: 0
        crossrefResultCountVariant: $crossrefResultCountVariant
      }
    ) {
      results {
        data {
          pubtype {
            main
          }
          ... on JournalSearchCrossRef {
            pubjournal {
              day
              month
              year
              title
              volume
              issue
              start
              end
            }
            id
            publication_type
            datasource
            contributors {
              first
              middle
              last
              function
            }
            journal {
              title
            }
            doi {
              doi
            }
            issn {
              print
            }
          }
          source
          other {
            datasource
            oclc
          }
        }
        display {
          title
          publisher
          year
          titleurl
        }
      }
    }
  }
`

export const SEARCH_WORLDCAT = gql`
  query SearchWorldcat($keywords: String!, $sourceType: SourceEnum) {
    searchCitationSource(
      searchInput: {
        keywords: $keywords
        provider: WORLDCAT
        from: 0
        sourceType: $sourceType
      }
    ) {
      results {
        data {
          source
          pubtype {
            main
            suffix
          }
          ... on WorldcatSearch {
            pubfilm {
              distributor
              year
              country
            }
            source
            contributors {
              first
              middle
              last
              function
            }
            pubtype {
              main
              suffix
            }
            pubnonperiodical {
              title
              publisher
              year
              city
              search
              titleurl
            }
            congress {
              congress
              committee
              billtype
              session
              year
            }
            fedbill {
              house
              title
              billtype
              congnum
            }
            pubfederal {
              source
              year
            }
            film {
              title
              mainperformers
            }
            govt {
              country
              agency
              office
            }
            map {
              type
            }
            musicalrecording {
              title
              producer
              yearproduced
              rectype
            }
            pubother {
              org
              city
              year
            }
            software {
              title
              type
            }
            thesis {
              title
              university
              yeargiven
            }
            dissertation {
              title
              university
              yeargiven
            }
            dissertationabstract {
              title
              university
              yeargiven
            }
          }
          other {
            datasource
            oclc
          }
        }
        display {
          title
          summary
          url
          titleurl
          displayurl
          publisher
          year
          date
          city
        }
      }
    }
  }
`
